module.exports = __webpack_public_path__ + "media/wo_jiao_yu_ting.1ee91a02.mp3";